import { useState } from "react";
import { Link } from "@tanstack/react-router";
import logoAsset from "@/assets/energie-prime-360-logo.png.asset.json";


const leistungen = [
  { label: "Analyse", href: "/was-analysieren-wir" },
  { label: "Vergleich", href: "/was-vergleichen-wir" },
  { label: "Fördermittel", href: "#projekt" },
  { label: "Finanzierung", href: "#projekt" },
  { label: "Steuerliche Potenziale", href: "#projekt" },
  { label: "Photovoltaik", href: "#projekt" },
  { label: "Batteriespeicher", href: "#projekt" },
  { label: "Wärmepumpen", href: "#projekt" },
  { label: "Sanierung", href: "#projekt" },
  { label: "Neubau", href: "#projekt" },
  { label: "Wohnersatzbau", href: "#projekt" },
  { label: "Gebäudeerweiterung", href: "#projekt" },
];

const nav: { label: string; href: string }[] = [
  { label: "Start", href: "/" },
  { label: "So funktioniert's", href: "/#prozess" },
  { label: "Leistungen", href: "#" },
  { label: "Über uns", href: "/was-ist-energy-prime-360" },
  { label: "Wissen", href: "/ergebnis" },
  { label: "Kontakt", href: "/#projekt" },
];

export function SiteNav() {
  const [openLeistungen, setOpenLeistungen] = useState(false);
  const [mobile, setMobile] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-[var(--rule)]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src={logoAsset.url}
            alt="Energie Prime 360"
            className="h-12 md:h-16 w-auto"
          />
        </Link>


        <nav className="hidden lg:flex items-center gap-7 text-[15px] text-navy">
          {nav.map((n) =>
            n.label === "Leistungen" ? (
              <div
                key={n.label}
                className="relative"
                onMouseEnter={() => setOpenLeistungen(true)}
                onMouseLeave={() => setOpenLeistungen(false)}
              >
                <button className="flex items-center gap-1 hover:text-[var(--leaf-deep)] transition py-2">
                  {n.label}
                  <svg viewBox="0 0 12 12" className="w-3 h-3 mt-0.5" fill="currentColor" aria-hidden>
                    <path d="M2 4l4 4 4-4z" />
                  </svg>
                </button>
                {openLeistungen && (
                  <div className="absolute left-1/2 -translate-x-1/2 top-full pt-2 w-[280px]">
                    <div className="bg-white rounded-lg shadow-xl border border-[var(--rule)] py-2 grid grid-cols-1">
                      {leistungen.map((l) => (
                        <a
                          key={l.label}
                          href={l.href}
                          className="px-4 py-2 text-sm text-navy hover:bg-[var(--sky-bg)] hover:text-[var(--leaf-deep)] transition"
                        >
                          {l.label}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <a key={n.label} href={n.href} className="hover:text-[var(--leaf-deep)] transition">
                {n.label}
              </a>
            ),
          )}
        </nav>

        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent("eve:open"))}
          aria-label="EVE Dein digitaler Assistent öffnen"
          className="hidden sm:inline-flex items-center gap-2 md:gap-3 bg-[var(--leaf)] hover:bg-[var(--leaf-deep)] text-white font-semibold pl-1.5 pr-4 md:pr-5 py-1.5 rounded-full text-sm shadow-md hover:shadow-lg transition"
        >
          <span className="inline-flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full bg-[var(--leaf)] ring-2 ring-white shadow-inner">
            <span className="inline-flex items-center justify-center w-full h-full rounded-full bg-white">
              <svg viewBox="0 0 40 40" className="w-6 h-6 md:w-7 md:h-7" aria-hidden>
                <rect x="8" y="10" width="24" height="22" rx="7" fill="none" stroke="var(--navy)" strokeWidth="2.2" />
                <line x1="20" y1="10" x2="20" y2="5" stroke="var(--navy)" strokeWidth="2.2" strokeLinecap="round" />
                <circle cx="20" cy="4" r="1.6" fill="var(--navy)" />
                <circle cx="15" cy="19" r="2" fill="var(--navy)" />
                <circle cx="25" cy="19" r="2" fill="var(--navy)" />
                <path d="M15 25 Q20 29 25 25" fill="none" stroke="var(--navy)" strokeWidth="2.2" strokeLinecap="round" />
              </svg>
            </span>
          </span>
          <span className="hidden md:inline whitespace-nowrap">EVE Dein digitaler Assistent</span>
        </button>

        <button
          className="lg:hidden p-2 text-navy"
          onClick={() => setMobile((o) => !o)}
          aria-label="Menü"
        >
          <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 6h18M3 12h18M3 18h18" />
          </svg>
        </button>
      </div>

      {mobile && (
        <div className="lg:hidden border-t border-[var(--rule)] bg-white">
          <div className="px-5 py-3 flex flex-col">
            {nav.map((n) => (
              <a
                key={n.label}
                href={n.href === "#" ? "/was-analysieren-wir" : n.href}
                className="py-2.5 text-navy border-b border-[var(--rule)] last:border-0"
                onClick={() => setMobile(false)}
              >
                {n.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => {
                setMobile(false);
                window.dispatchEvent(new CustomEvent("eve:open"));
              }}
              className="mt-3 inline-flex items-center justify-center gap-2 bg-[var(--leaf)] text-white font-medium px-4 py-2.5 rounded-md text-sm"
            >
              EVE Dein digitaler Assistent
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
